import { PlusIcon, DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import CommonPageHeader from "../components/common/CommonPageHeader";
import TemplateLists from "components/templates/TemplateLists";
import { useLanguage } from "contexts/LanguageContext";
import { useState } from "react";
import { useAuth } from "contexts/AuthContext";

const Templates = () => {
  const { t } = useLanguage();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t("templates.title")}
        subtitle="Dokumentum sablonok kezelése"
        icon={DocumentDuplicateIcon}
        showLastUpdate={false}
      >
        {user?.role !== 'user' && (
          <button
            onClick={() => setIsCreateModalOpen(true)}
            className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors"
          >
            <PlusIcon className="w-5 h-5 mr-2" />
            {t("templates.newTemplate")}
          </button>
        )}
      </CommonPageHeader>

      {/* Szerződések listája */}
      <TemplateLists
        isCreateModalOpen={isCreateModalOpen}
        setIsCreateModalOpen={setIsCreateModalOpen}
      />
    </div>
  );
}

export default Templates;